export default __webpack_public_path__ + "static/27-45db5fd79e57205f93711b9e13a47034.jpg";